import { render, staticRenderFns } from "./detailsPageChart.vue?vue&type=template&id=e7f76a36&scoped=true&"
import script from "./detailsPageChart.vue?vue&type=script&lang=js&"
export * from "./detailsPageChart.vue?vue&type=script&lang=js&"
import style0 from "./detailsPageChart.vue?vue&type=style&index=0&id=e7f76a36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f76a36",
  null
  
)

export default component.exports